module.exports = __webpack_public_path__ + "files/b3c2f8e6e0cee4daee5cf55f2af65a55.png";